import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const ChevronTop = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      width={computedSize}
      height={computedSize}
      fill={color}
      {...props}
    >
      <path
        fill="#344054"
        fillRule="evenodd"
        d="M4.44 13.33a.78.78 0 0 1-.28-1.06l.01-.01.01-.02.03-.05c.03-.05.07-.11.12-.19.09-.14.21-.32.37-.57.36-.55.84-1.25 1.38-1.93.53-.67 1.13-1.34 1.75-1.87.58-.5 1.24-.96 1.91-.96s1.33.46 1.91.96c.62.53 1.22 1.2 1.75 1.87.54.68 1.02 1.38 1.38 1.93.16.25.28.43.37.57.05.08.09.14.12.19l.03.05.01.02.01.01c.21.36.09.85-.28 1.06-.36.21-.85.09-1.06-.27-.07-.11-.17-.25-.29-.43-.27-.39-.63-.91-1.06-1.49s-.92-1.15-1.41-1.56c-.52-.44-.94-.62-1.48-.62-.53 0-.95.18-1.47.62-.49.41-.98.98-1.41 1.56s-.79 1.1-1.06 1.49c-.12.18-.22.32-.29.43-.21.36-.7.48-1.07.27"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default ChevronTop;
